import { withStyles } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Trans, useTranslations } from "../../../adapters/i18n";
import * as action from "../../../redux/actions";
import { useChangePassword } from "../hooks/useChangePassword";
import ChangePasswordSkeletonLoading from "./components/ChangePasswordSkeletonLoading";
import PageLayout from "./components/PageLayout";
import PasswordInput from "./components/PasswordInput";
import styles from "./NewLoginPage/styles";

export function ChangePasswordPage({
  match,
  classes,
  notifyError,
  notifySuccess,
}) {
  const { token } = match.params || {};
  const { t } = useTranslations();

  const { isTokenValid, loading, error, onSubmit, onChange } =
    useChangePassword({ token, notifyError, notifySuccess });

  if (loading) {
    return (
      <PageLayout>
        <ChangePasswordSkeletonLoading />
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      {isTokenValid ? (
        <div className={classes.content}>
          <div className={classes.greetings}>
            <h1 className={classes.greetingWelcome}>
              {t("login:password-creation")}
            </h1>
            <p className={classes.greetingsMessage}>
              {t("login:create-password-instructions")}
            </p>
          </div>

          <form className={classes.form} onSubmit={onSubmit}>
            <PasswordInput
              label={t("login:password")}
              inputName="password"
              placeholder={t("login:enter-new-password")}
              error={error}
              onChange={onChange}
            />
            <PasswordInput
              label={t("login:confirm-password")}
              inputName="passwordConfirmation"
              placeholder={t("login:repeat-password")}
              error={error}
              onChange={onChange}
            />

            <div className={classes.passwordCreationRules}>
              <div className={classes.passwordCreationRulesSection}>
                <p>
                  <Trans
                    i18nKey="login:password-rules.title"
                    components={[<strong />]}
                  />
                </p>
                <p>{t("login:password-rules.min-length")}</p>
              </div>

              <div className={classes.passwordCreationRulesSection}>
                <p>{t("login:password-rules.character-restrictions")}</p>
                <div style={{ marginLeft: 4 }}>
                  <p>{t("login:password-rules.lowercase")}</p>
                  <p>{t("login:password-rules.uppercase")}</p>
                  <p>{t("login:password-rules.number")}</p>
                </div>
              </div>

              <div className={classes.passwordCreationRulesSection}>
                <p>{t("login:password-rules.special-character-option")}</p>
                <p>
                  <Trans
                    i18nKey="login:password-rules.special-characters"
                    components={[<strong />]}
                  />
                </p>
              </div>
            </div>

            <button className={classes.submitButton} type="submit">
              {t("login:save-password")}
            </button>
          </form>
          <div className={classes.footer}>
            <p className={classes.footerHighlight}>
              {t("common:status.attention")}
            </p>
            <p>
              <Trans
                i18nKey="login:password-reset-link-validity"
                components={[<span className={classes.footerHighlight} />]}
              />
            </p>
          </div>
        </div>
      ) : (
        <InvalidToken classes={classes} />
      )}
    </PageLayout>
  );
}

const InvalidToken = ({ classes }) => {
  const { t } = useTranslations();

  return (
    <div className={classes.invalidTokenContent}>
      <p>{t("login:password-reset-link-expired")}</p>
      <img
        src="../images/sad-cloud.svg"
        alt="sad-cloud"
        style={{ width: "450px", height: "200px" }}
      />
    </div>
  );
};

const mapDispatchToProps = {
  notifyError: action.notifyError,
  notifySuccess: action.notifySuccess,
};

export default compose(
  connect(null, mapDispatchToProps),
  withStyles(styles)
)(ChangePasswordPage);
